export default function(mutations, mutationCheck) {
  // Server returned null/empty array, no mutation allowed
  if (!mutations) return false;
  // Loop until a mutation name thats in mutations Array is found
  return (
    (mutationCheck.constructor === Array &&
      mutationCheck.some(r => mutations.includes(r))) ||
    mutations.includes(mutationCheck)
  );
}
